import { render, staticRenderFns } from "./ExcelUploadBatchDetails.vue?vue&type=template&id=1530f16c&scoped=true"
import script from "./ExcelUploadBatchDetails.vue?vue&type=script&lang=js"
export * from "./ExcelUploadBatchDetails.vue?vue&type=script&lang=js"
import style0 from "./ExcelUploadBatchDetails.vue?vue&type=style&index=0&id=1530f16c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1530f16c",
  null
  
)

export default component.exports